import React, { useState, useEffect } from 'react';

import './dynamic-image-gallery.css';

const DynamicImageGallery = (props) => {
  const [ImageGallery, setImageGallery] = useState(null);

  useEffect(() => {
    if(typeof window !== 'undefined'){
        // The dynamic import is only called on the client-side, after the component mounts.
        import('react-image-gallery').then((module) => {
        // The .default is needed because react-image-gallery uses a default export.
        setImageGallery(() => module.default);
        });

        // Dynamically import the CSS as well to ensure styles are applied.
        // The linter doesn't know that importing a CSS file has a side-effect.
        // eslint-disable-next-line no-unused-expressions
        import('react-image-gallery/styles/css/image-gallery.css');
    }
  }, []);

  // On the server, and on the initial client-side render, ImageGallery will be null.
  // We can render a placeholder. It's good practice to give it a min-height
  // to prevent layout shifts when the real component loads.
  if (!ImageGallery) {
    return <div style={{ minHeight: 500, backgroundColor: '#acd4c4' }} aria-label="Loading image gallery" />;
  }

  // Once the component is loaded on the client, we can render it with the passed props.
  return <ImageGallery 
            showNav={false} 
            showPlayButton={false} 
            showBullets={true} 
            autoPlay={true} 
            slideInterval={5000} 
            {...props} />;
};

export default DynamicImageGallery;
